import React, {useState, useEffect, useRef, createContext} from 'react';
import { BsChevronExpand } from 'react-icons/bs';
import '../common/css/common.css';
import '../common/css/sites_list.css';
import * as SiteApi from '../common/fetch_api/site.js';
import {useInterval, stateMapClear} from '../common/app_common.js';
import {TitleDetail, TopSitesAlertStatusSection, PageNation} from '../common/component_common.js';
import SiteDetail from './sites_list/site_detail';
import MediaMonitoring from './sites_list/media';
import SchedulerMonitoring from './sites_list/scheduler';
import RedundantMonitoring from './sites_list/redundant';
import RedundantMonitoringStatus from './sites_list/redundant';
import TransmitterMonitoring from './sites_list/transmitter';

export const TermRefreshContext = createContext();

const PAGE_PER = 17;

const PageSitesList = () =>
{
    let page = sessionStorage.getItem('pageName');
    const [pageName, setPageName] = useState(page ?? 'siteList');
    sessionStorage.setItem('pageName', pageName);

    const [siteInfo, setSiteInfo] = useState(null);
    const [edgeInfo, setEdgeInfo] = useState(null);

    useEffect(() =>
    {
        if(JSON.parse(sessionStorage.getItem('siteInfo')))
        {
            setSiteInfo(JSON.parse(sessionStorage.getItem('siteInfo')));
        }
        else
        {
            setPageName('siteList');
        }
        
        if(JSON.parse(sessionStorage.getItem('edgeInfo')))
        {
            setEdgeInfo(JSON.parse(sessionStorage.getItem('edgeInfo')));
        }
        else
        {
            setPageName('siteList');
        }

    }, []);

    return (
        <>
            { pageName === 'siteList' &&  <SiteListTable setPageName={setPageName} setSiteInfo={setSiteInfo} />}
            { pageName === 'siteDetail' &&  siteInfo && <SiteDetail setPageName={setPageName} siteInfo={siteInfo} setEdgeInfo={setEdgeInfo}/>}
            { pageName === 'mediaMonitoring' &&  edgeInfo && <MediaMonitoring setPageName={setPageName} siteInfo={siteInfo} edgeInfo={edgeInfo} />}
            { pageName === 'schedulerMonitoring' && edgeInfo  && <SchedulerMonitoring setPageName={setPageName} siteInfo={siteInfo} edgeInfo={edgeInfo} />}
            { pageName === 'redundantMonitoring' && edgeInfo  && <RedundantMonitoring setPageName={setPageName} siteInfo={siteInfo} edgeInfo={edgeInfo} />}
            { pageName === 'transmitterMonitoring' && edgeInfo && <TransmitterMonitoring setPageName={setPageName} siteInfo={siteInfo} edgeInfo={edgeInfo} />}
        </>
    )
}

export default PageSitesList;

const SiteListTable = ({setPageName, setSiteInfo }) =>
{
    const [pageSelCount, setPageSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const [sitesListArr, setSitesListArr] = useState([]);

    const [sitesTbody, setSitesTbody] = useState(null);
    const [sitesAlertStatusArr, setSitesAlertStatusArr] = useState(null);

    //TopSitesAlertStatusSection 에서 받아옴
    const [searchName, setSearchName] = useState('');
    const [searchType, setSearchType] = useState('');

    const [sorting, setSorting] = useState({sortType: 'name', sortOrder: 'asc'});

    const [edgeSeverity, setEdgeSeverity] = useState(new Map());
    const [sortSiteAlertStatus, setSortSiteAlertStatus] = useState('');

    const [tableSpinner, setTableSpinner] = useState(false);

    const onClickSiteDetail = (siteInfo) =>
    {
        setPageName('siteDetail');
        setSiteInfo(siteInfo);
        sessionStorage.setItem('siteInfo', JSON.stringify(siteInfo));
    }

    const onClickSort = (criteria) => () => {
        let sortByOrder = sorting.sortOrder === 'asc' ? 'desc' : 'asc';
    
        setSorting({
            ...sorting,
            sortType: criteria,
            sortOrder: sortByOrder
        });
    };

    const selectSiteSeverity = (status) =>
    {
        //severity click 시 처리
        setSortSiteAlertStatus(status);
    }

    const getSites = async () =>
    {
        try {
            curPageRef.current.value = curPageState;
    
            if (searchType === '' || searchType === 'market')
            {
                await fetchSitesByMarket();
            }
            else if (searchType === 'callsign')
            {
                await fetchSiteByCallsign();
            }
        }
        catch (error)
        {
            console.error('Error fetching sites:', error);
        }
        finally
        {
            setTimeout(() => {setTableSpinner(false);}, 700);
        }
    };
    
    const fetchSitesByMarket = async () =>
    {
        const countData = await SiteApi.getApiSitesCount(searchName, sortSiteAlertStatus);
        const count = countData?.count || 0;
        setPageSelCount(Math.max(count, 1));
    
        const [sitesList, sitesSeverity] = await Promise.all(
        [
            SiteApi.getApiSites(PAGE_PER, curPageState, searchName ?? '', sortSiteAlertStatus, sorting.sortType, sorting.sortOrder),
            SiteApi.getApiSitesAlertStatus()
        ]);
    
        //TopSitesAlertStatusSection 에 전달 TopSitesAlertStatusSection 에 전체 사이트 표시를 위해 getApiSitesAlertStatus 호출도 필요함
        //search에서 select된 사이트의 severity 를 표현해서 넘겨주어야 함
        setSitesAlertStatusArr(Array.isArray(sitesSeverity) ? sitesSeverity : null);
    
        if (Array.isArray(sitesList) && sitesList.length > 0)
        {
            const sitesInfoArr = await Promise.all(sitesList.map((item) => SiteApi.getApiSitesSite(item.site)));
            setSitesListArr(sitesInfoArr);
            makeEdgeSeverityData(sitesInfoArr);
        }
        else
        {
            clearSitesData();
        }
    };
    
    const fetchSiteByCallsign = async () =>
    {
        if (!searchName)
        {
            clearSitesData();
            return;
        }
    
        setPageSelCount(1);
        setCurPageState(1);
    
        const site = await SiteApi.getApiSitesSite(searchName);
        if (site)
        {
            // callsign site가 하나이기때문에 배열로 set
            setSitesListArr([site]);
            makeEdgeSeverityData([site]);
        }
    };
    
    const clearSitesData = () =>
    {
        setPageSelCount(1);
        setCurPageState(1);
        stateMapClear(setEdgeSeverity);
        setSitesListArr([]);
        setSitesTbody(null);
    };

    //그동안 update 항목으로 실행하던것을 call getSites로 변경, 인자는 페이지를 set 하는것.
    function callGetSites(initPage)
    {
        setTableSpinner(true);
        getSites();
        if( initPage )
        {
            setCurPageState(1);
        }
    }
    
    const firstLoading = useRef(true);
    //여기는 페이지로딩시 실행이 안되게, 그후 변화가 있을때 실행
    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            // console.log('페이지 강제이동 O, 로딩 1')
            // page set 인자로 'true'
            callGetSites(true);
        }
    }, [searchName, sortSiteAlertStatus, sorting]);

    //여기도 페이지 로딩시 실행안됨, 페이지 바꿀때.
    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            // console.log('페이지 강제이동 X, 로딩 1');
            callGetSites(false);
        }
    }, [curPageState]);

    //처음 실행하지만, searchType 에 'all' value가 빈배열 0 일때 실행 안되게
    useEffect(() =>
    {
        // 위 useEffect 랑 같이 두번실행되서 아래 first.current 로 막아서 한번만 실행        
        if(firstLoading.current || searchType.length > 0) // all 일때
        {
            return;
        }

        // console.log('페이지 강제이동 O 로딩 2');
        callGetSites(true);
        
    }, [searchType]);

    //페이지 첫 로딩, firstLoading 만 바꾸어줌. **순서가 중요함. 첫로딩 useEffect가 맨 마지막에 와야함.
    useEffect(() =>
    {
        callGetSites(true);
        firstLoading.current = false;
    }, []);

    useEffect(() =>
    {
        // 위 edge severity map 이 변화가 있으면 html 생성
        makeTbody();
    },[edgeSeverity])

    useInterval(() =>
    {
        callGetSites(false);
    }, 5000 );

    const makeEdgeSeverityData = (dataArr) =>
    {
        // 첫 로딩시 edge 정보 콘솔 출력
        console.log('[sites_list] Edge 정보:', dataArr.map(s => ({ name: s.name, edgeList: s.edgeList })));

        const newEdgeSeverity = new Map();

        dataArr.forEach((siteInfo) =>
        {
            let mAgentStatus = 'good';
            let sAgentStatus = 'good';
            let rAgentStatus = 'good';
            let rmStatus = 'good';

            siteInfo.edgeList.forEach((edge) =>
            {
                if (edge.severity === 'critical')
                {
                    if (edge.type === 'm-agent') mAgentStatus = 'critical';
                    else if (edge.type === 's-agent') sAgentStatus = 'critical';
                    else if (edge.type === 'r-agent') rAgentStatus = 'critical';
                    else if (edge.type === 'rm') rmStatus = 'critical';
                }
                else if (edge.severity === 'warning')
                {
                    if (edge.type === 'm-agent' && mAgentStatus !== 'critical') mAgentStatus = 'warning';
                    else if (edge.type === 's-agent' && sAgentStatus !== 'critical') sAgentStatus = 'warning';
                    else if (edge.type === 'r-agent' && rAgentStatus !== 'critical') rAgentStatus = 'warning';
                    else if (edge.type === 'rm' && rmStatus !== 'critical') rmStatus = 'warning';
                }
            });

            newEdgeSeverity.set(siteInfo.name, { mAgent: mAgentStatus, sAgent: sAgentStatus, rAgent: rAgentStatus, rm: rmStatus });
        });

        setEdgeSeverity(newEdgeSeverity);
    }

    const makeTbody = () =>
    {
        if (sitesListArr && edgeSeverity)
        {
            const html = sitesListArr.map((siteInfo) =>
            {
                const mAgentArr = siteInfo.edgeList.filter((x) => x.type === 'm-agent');
                const mAgentLen = mAgentArr.length;

                const sAgentArr = siteInfo.edgeList.filter((x) => x.type === 's-agent');
                const sAgentLen = sAgentArr.length;

                const rAgentArr = siteInfo.edgeList.filter((x) => x.type === 'r-agent');
                const rAgentLen = rAgentArr.length;

                const rmArr = siteInfo.edgeList.filter((x) => x.type === 'rm');
                const rmLen = rmArr.length;

                const mAgentStatus = edgeSeverity.has(siteInfo.name) && `bg-${edgeSeverity.get(siteInfo.name).mAgent}`;
                const sAgentStatus = edgeSeverity.has(siteInfo.name) && `bg-${edgeSeverity.get(siteInfo.name).sAgent}`;
                const rAgentStatus = edgeSeverity.has(siteInfo.name) && `bg-${edgeSeverity.get(siteInfo.name).rAgent}`;
                const rmStatus = edgeSeverity.has(siteInfo.name) && `bg-${edgeSeverity.get(siteInfo.name).rm}`;

                return (
                    <tr key={siteInfo.name} onClick={() => onClickSiteDetail(siteInfo)}>
                        <td>{siteInfo.name}</td>
                        <td>{siteInfo.market}</td>
                        <td className={`text-${siteInfo.severity}`}>{siteInfo.severity.replace(/\b[a-z]/g, char => char.toUpperCase())}</td>
                        <td>
                            <div className={`edge-box ${mAgentLen ? mAgentStatus : 'disable-edge'}`}>
                                <span className="edge-item">M{mAgentLen > 1 && <span className="badge bg-danger">{mAgentLen}</span>}</span>
                            </div>
                            <div className={`edge-box ${sAgentLen ? sAgentStatus : 'disable-edge'}`}>
                                <span className="edge-item">S{sAgentLen > 1 && <span className="badge bg-danger">{sAgentLen}</span>}</span>
                            </div>
                            <div className={`edge-box ${rAgentLen ? rAgentStatus : 'disable-edge'}`}>
                                <span className="edge-item">R{rAgentLen > 1 && <span className="badge bg-danger">{rAgentLen}</span>}</span>
                            </div>
                            <div className={`edge-box ${rmLen ? rmStatus : 'disable-edge'}`}>
                                <span className="edge-item">T{rmLen > 1 && <span className="badge bg-danger">{rmLen}</span>}</span>
                            </div>
                        </td>
                    </tr>
                );
            });

            setSitesTbody(html);
        }
    };

    return (
        <>
            <TitleDetail setPageName={setPageName}></TitleDetail>
            <div className="d-flex flex-column mt-2">
                <div className="d-flex flex-wrap">
                    <TopSitesAlertStatusSection searchName={searchName} setSearchName={setSearchName} searchType={searchType} setSearchType={setSearchType} sitesSeveriry={sitesAlertStatusArr} selectSiteSeverity={selectSiteSeverity} active={true}/>
                </div>
                <div className="d-flex flex-column">
                    <div className="section sites-list-table position-relative">
                        {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="sorting" onClick={onClickSort('name')}>Callsign<BsChevronExpand /></th>
                                    <th className="sorting" onClick={onClickSort('market')}>Market<BsChevronExpand /></th>
                                    <th>Status</th>
                                    <th>Edge</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sitesTbody}
                            </tbody>
                        </table>
                    </div>
                    <PageNation
                        curPageState={curPageState}
                        setCurPageState={setCurPageState}
                        selCount={pageSelCount}
                        pagePer={PAGE_PER}
                        ref={curPageRef}
                    ></PageNation>
                </div>
            </div>
        </>
    )
}